import Bullets from "@/components/Bullets/Bullets";
import { Separator } from "@radix-ui/react-separator";

const Specs = ({ tablist }) => {
  return (
    <div className="container mt-8">
      <h2 className="lg:text-5xl text-4xl lg:mb-4">Ausstattung</h2>
      {Object.entries(tablist)
        .filter(
          ([_, content]) =>
            Object.keys(content as { [key: string]: string }).length > 0
        )
        .map(([title, content], index) => {
          return (
            <div key={index} className="mt-8">
              <div className="font-bold lg:text-2xl text-base mb-6">
                {title}
              </div>
              <Bullets
                className={`lg:ml-4 ml-4 lg:grid-cols-3 md:grid-cols-2 lg:gap-y-6 gap-y-4 text-sm grid  text-gray-600  lg:mt-6 md:ml-5`}
                type={0}
                items={Object.values(content as { [key: string]: string })}
              />
              <Separator
                orientation="horizontal"
                className="!bg-gray-300 !h-1 mt-8"
              />
            </div>
          );
        })}
    </div>
  );
};
export default Specs;
